import React from 'react'
import Resume1 from "../assets/aritra-bhattacharjee-resume.pdf"
import "./CSS/resume.css"

export default function Resume() {
  document.title = "Resume - Aritra "
  return (
    <div className='container my-4'>
        <iframe allow='' id="pdf" title='Myresume' src={Resume1} frameborder="0"></iframe>

    </div>
  )
}
 